import { alpha, Grid, Toolbar, Typography } from '@mui/material';
import { memo, useMemo } from 'react';
import TableCheckbox from 'shell/components/shared/table-checkbox';
import { noop } from 'shell/utils/noop';
import { FamilyVM } from './family-vm';
import headCellsPracticesAssign from './head-cells';

interface TableFamilyFormProps {
  disabled?: boolean;
  disabledAll?: boolean;
  values: Array<FamilyVM>;
  onChange: (familyMembers: Array<FamilyVM>) => void;
  codeEnte?: string;
  yearId?: string;
  typeRegister?: string;
  progressive?: string;
  typePractice?: string;
  disabledResidente?: boolean;
}

const TableFamilyFormComponent = ({
  values,
  disabledResidente,
}: TableFamilyFormProps): React.ReactElement => {
  const body = useMemo(() => {
    return values?.slice().map((item) => {
      return {
        ...item,
        disabledCheckbox: true,
        checked: true,
      };
    });
  }, [values, disabledResidente]);

  const count = useMemo(() => {
    return values.reduce((prev, next) => prev + (next.checked || next.selectedFromDb ? 1 : 0), 0);
  }, [values]);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Toolbar
          sx={{
            pl: { sm: 2 },
            pr: { xs: 1, sm: 1 },
            ...(count >= 0 && {
              bgcolor: (theme) =>
                alpha(theme.palette.cdmBrandThird.main, theme.palette.action.activatedOpacity),
            }),
          }}
        >
          <Typography sx={{ flex: '1 1 100%' }} color="inherit" variant="subtitle1" component="div">
            {count} {count === 1 ? 'selezionato' : 'selezionati'}
          </Typography>
        </Toolbar>
        <TableCheckbox
          minWidth={600}
          head={headCellsPracticesAssign}
          body={body}
          onCheckPress={noop}
          onSelectAll={noop}
          disabled
        />
      </Grid>
    </Grid>
  );
};

TableFamilyFormComponent.displayName = 'Table family form component';

const TableFamilyForm = memo(TableFamilyFormComponent);

export default TableFamilyForm;
